import { render } from "./PageUsps.vue?vue&type=template&id=751120a0"
import script from "./PageUsps.vue?vue&type=script&lang=js"
export * from "./PageUsps.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__